import { RichTextBlock } from 'prismic-reactjs';
import gql from 'graphql-tag';
import { IImage, ILink } from 'utils/types';
import { IBaseSlice, SliceTypes } from '..';
import { fetchJobs, parseJobs } from '../../job';
import { parser } from '../../utils/parsers';

export interface IJobListing extends IBaseSlice {
  tagline: string;
  title: string;
  items: Array<{
    tagline: string;
    title: string;
    date: string;
    location: string;
    summary: RichTextBlock[];
    image: IImage;
    text: RichTextBlock[];
    link: ILink;
  }>;
}

export const fragment = (name: string, type: string, fragmentName: string) => gql`
  fragment ${fragmentName || name} on ${type} {
    ... on ${type}${name} {
      type
      primary {
        slice_tagline
        slice_title
      }
    }
  }
`;

type NestedProps = {
  lang: string;
  limit?: number;
  previewData: boolean;
  redirects: Array<{ from: string; to: string }>;
};

export const fetchJobsAndParse = async ({
  lang,
  limit,
  previewData,
  redirects = [],
}: NestedProps) => {
  const items = await fetchJobs(lang, '', previewData, limit);
  return parseJobs(items, redirects, lang);
};

type Props = {
  primary: {
    slice_tagline: RichTextBlock[];
    slice_title: RichTextBlock[];
  };
};

export const parse = (slice: Props): IJobListing => ({
  type: SliceTypes.JobListing,
  tagline: parser.string(slice.primary.slice_tagline),
  title: parser.string(slice.primary.slice_title),
  items: [],
});
